import Vue from 'vue'
import config from '@/config'

export default {
  SET_AUTH_TOKEN (state, payload) {
    state.authToken = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('authToken', payload)
    }
  },

  SET_USER_DATA (state, payload) {
    state.userData = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('userData', JSON.stringify(payload))
    }
  },

  SET_USER_TENANT_ID (state, payload) {
    state.userTenantId = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('userTenantId', payload)
    }
  },

  SET_LAST_REFRESH_TIME (state, payload) {
    state.lastTokenRefreshAt = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('lastTokenRefreshAt', payload)
    }
  },

  SET_LAST_ACTION_TIME (state, payload) {
    state.lastActionAt = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('lastActionAt', payload)
    }
  },

  SET_TOKEN_EXPIRE_IN_MINUTES (state, payload) {
    state.tokenExpireInMinutes = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('tokenExpireInMinutes', payload)
    }
  },
}
